/* External */
import {
  memo, useState, useCallback, useRef, useEffect,
} from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

/* Ott-common */
import Toast from '@dtvgo/toast';

/* Components */
import LanderPage from '../../../components/LanderPage';
import Epg from '../../../components/Epg';
// It should be removed from the code when pages v4 is the final version.
import UpSellBanner from '../../../components/UpSellBanner';
import ScrollIntoViewIfFocused from '../../../components/ScrollIntoViewIfFocused';

/* Utils */
import useOnLeftArrowPress from '../../../hooks/useOnLeftArrowPress';
import useSelectedEpgFilter, { getSavedSelectedFilter } from '../../../hooks/useSelectedEpgFilter';
import { useOpenSidebar } from '../../../providers/SidebarStateContext';
import { EPG_FILTERS_ID, PageType } from '../../../utils/constants';
import useEpgFilters from '../../../hooks/useEpgFilters';
import { useCountry } from '../../../providers/ConfigProvider';
import { useGtmLocalContext } from '../../../providers/GtmLocalProvider';
import { GTM_CATEGORIES, GTM_EVENT_NAMES, GTM_SUBCATEGORIES } from '../../../utils/googleTags';
import { ScrollPosition } from '../../../components/ScrollView';
import { getIsCurableBannerActive } from '../../../utils/functions';

/* Hooks */
import useGetUpSellBannerMessage from '../../../hooks/useGetUpSellBannerMessage';

/* Styles */
import './Live.scss';

function Live() {
  const location = useLocation();
  const isCurableBannerActive = getIsCurableBannerActive();

  const goToSidebar = useOpenSidebar();
  const [initialScrollPositionEpg, setInitialScrollPositionEpg] = useState(() => Number.parseFloat(sessionStorage.getItem('offsetEpg')) || 0);
  const [isRecentlyWatchedFetched, setIsRecentlyWatchedFetched] = useState();
  const { filters } = useEpgFilters();
  const country = useCountry();

  const {
    showUpSellBanner,
  } = useGetUpSellBannerMessage(isCurableBannerActive) || {};

  const {
    isFetching: isFetchingChannels,
    channels,
    selectedFilter,
    isInitialFilter,
    handleFilterSelect,
  } = useSelectedEpgFilter({
    filters,
    defaultFilter: (getSavedSelectedFilter() || EPG_FILTERS_ID.ALL_STATIONS),
  });

  const handleLeftArrowPress = useOnLeftArrowPress(goToSidebar);

  const handleOnFetchRecentlyWatched = useCallback(
    (hasFetched) => setIsRecentlyWatchedFetched(!!hasFetched),
    [],
  );

  const { commonTaggingEvent } = useGtmLocalContext();
  const tagsMountRef = useRef(true);

  const [showToast, setShowToast] = useState(false);
  const blockContentToastText = <FormattedMessage id="profile.error.parental.toast.title" />;
  const blockContentToastSubText = <FormattedMessage id="profile.error.parental.toast.subtitle" />;

  useEffect(() => {
    let toastTimeout;
    if (JSON.parse(sessionStorage.getItem('showToastParentalBlock'))) {
      setShowToast(true);
      sessionStorage.setItem('showToastParentalBlock', false);
      toastTimeout = setTimeout(() => {
        setShowToast(false);
      }, 5000);
    }
    return () => {
      if (toastTimeout) clearTimeout(toastTimeout);
    };
  }, []);

  useEffect(() => {
    if (tagsMountRef.current && country) {
      commonTaggingEvent({
        category: GTM_CATEGORIES.LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA,
        subCategory: GTM_SUBCATEGORIES.PAGES.LIVE_PAGE,
        eventName: GTM_EVENT_NAMES.PAGE_VIEW,
      });
      tagsMountRef.current = false;
    }
  }, [commonTaggingEvent, country, location, setShowToast]);

  return (
    <div className="dtv-html5-c-live-page">
      <Toast className="dtv-html5-c-toast-live" show={showToast} text={blockContentToastText} subText={blockContentToastSubText} type="notification" />
      <LanderPage pageId={PageType.LIVE} className="dtv-html5-c-live" withoutTitle onFetchRecentlyWatched={handleOnFetchRecentlyWatched}>
        <Epg
          channels={channels}
          onLeftArrowPress={handleLeftArrowPress}
          pageId={PageType.LIVE}
          isLoading={isFetchingChannels}
          initialScrollPosition={isInitialFilter ? initialScrollPositionEpg : 0}
          setInitialScrollPosition={setInitialScrollPositionEpg}
          filters={filters}
          selectedFilterId={selectedFilter?.id}
          onFilterSelect={handleFilterSelect}
          emptyChannelsMessage={selectedFilter?.emptyMessages}
          isRecentlyWatchedFetched={isRecentlyWatchedFetched}
        />
        {showUpSellBanner && (
          <ScrollIntoViewIfFocused position={ScrollPosition.CENTER}>
            <UpSellBanner />
          </ScrollIntoViewIfFocused>
        )}
      </LanderPage>
    </div>
  );
}

Live.propTypes = {};

export default memo(Live);
